import React, { useState, useEffect } from 'react';
import './index.scss';
import http from '../../utils/http';
import { GetRequest, } from '../../utils/util';
import rightIcon from '../../assets/right-icon.png';

const AdvPromotion = () => {
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState('');
    const [advData, setAdvData] = useState({});
    const [urlParams, setUrlParams] = useState({});

    // 获取URL参数
    const getUrlParams = () => {
        const params = GetRequest();
        document.title = "淘宝红包";
        const { userId, projectId, loginCode, accountId, telephone, phoneSystem } = params;
        setUrlParams({
            userId: userId,
            projectId: projectId,
            loginCode: loginCode,
            accountId: accountId,
            telephone: telephone,
            phoneSystem: phoneSystem,
        });
        return {
            userId: userId,
            projectId: projectId,
            loginCode: loginCode,
            accountId: accountId,
            telephone: telephone,
            phoneSystem: phoneSystem,
        }
    };

    // 加载配置数据
    const loadConfig = async () => {
        try {
            setLoading(true);
            setError('');

            // 获取URL参数
            const params = getUrlParams();

            // 调用API获取广告数据
            const response = await http("get", '/project/adv/ali/list', params);
            if (response && response.errorCode === 0) {
                const { aplus_queue } = window;
                aplus_queue.push({
                    action: 'aplus.record',
                    arguments: ['adv_show', 'CLK',]
                });
                const data = response.data || {};
                let advInfo = data.filter(item => item.customAdvFlag === 2 && item.deepLink);
                // 检查customAdvFlag是否等于2
                setAdvData(advInfo[0]);

                // 拿到配置参数后立即执行changeEmbedding，直接传递数据而不是依赖状态
                if (advInfo[0].deepLink) {
                    document.title = advInfo[0].customAdvName + '红包';
                    // 打开支付宝小程序页面 
                    const { aplus_queue } = window;
                    aplus_queue.push({
                        action: 'aplus.record',
                        arguments: ['adv_trigger', 'CLK',]
                    });
                    window.location.href = `${advInfo[0].deepLink}`;
                }
            } else {
                setError(response.message || '获取广告数据失败');
            }
        } catch (err) {
            console.error('加载广告数据失败:', err);
            setError('加载失败，请重试');
        } finally {
            setLoading(false);
        }
    };

    // 领取红包
    const changeEmbedding = () => {
        // 打开支付宝小程序页面    
        const { aplus_queue } = window;
        aplus_queue.push({
            action: 'aplus.record',
            arguments: ['adv_trigger', 'CLK',]
        });
        window.location.href = `${advData.deepLink}`;
    };

    // 返回
    const changeGoBack = () => {
        // 在小程序环境中，尝试多种返回方式
        try {
            // 优先尝试使用支付宝小程序的API返回
            if (window.AlipayJSBridge && window.AlipayJSBridge.call) {
                window.AlipayJSBridge.call('popWindow');
            } else {
                // 如果不在小程序环境中，使用浏览器历史返回
                window.history.back();
            }
        } catch (error) {
            console.error('返回失败:', error);
            // 如果所有方法都失败，尝试关闭当前页面
            if (window.AlipayJSBridge && window.AlipayJSBridge.call) {
                window.AlipayJSBridge.call('closeWebview');
            }
        }
    };

    useEffect(() => {
        loadConfig();
    }, []);



    return (
        <div className="adv-page">
            {/* 加载状态 */}
            {loading && (
                <div className="loading-container">
                    <span>加载中...</span>
                </div>
            )}

            {/* 错误提示 */}
            {error && (
                <div className="error-container">
                    <span>{error}</span>
                    <button type="primary" onClick={loadConfig} className="retry-btn">重试</button>
                </div>
            )}
            {/* 广告数据显示容器 */}
            {/* <div className="adv-data-container">
                <div className="params-title">广告数据</div>
                <div className="param-item">广告名称: {advData.customAdvName || '专属'}</div>
                <div className="param-item">广告ID: {advData.advId || ''}</div>
                <div className="param-item">红包金额: {advData.amount || ''}</div>
                <div className="param-item">有效期: {advData.validTime || ''}</div>
                <div className="param-item">小程序AppId: {advData.customAdvAppId || ''}</div>
                <div className="param-item">小程序路径: {advData.customAdvPath || ''}</div>
                <div className="param-item">自定义参数: {advData.customAdvParam || ''}</div>
                <div className="param-item">完整链接: {`alipays://platformapi/startapp?appId=${advData.customAdvAppId}&page=${advData.customAdvPath}${advData.customAdvParam ? '&query=' + advData.customAdvParam : ''}`}
                </div>
            </div> */}
            {/* 正常内容 */}
            {!loading && !error && (
                <div className="order-advertisement-content">

                    <div className="advertisement" onClick={changeEmbedding}>
                        <div className="advertisement-title">
                            恭喜您获得
                            <span style={{ color: '#EA4542' }}>{advData.customAdvName || '专属'}红包</span>，点击确定领取
                        </div>
                        <div className="lingqu">
                            领取
                            <img
                                className="gengduo-img"
                                src={rightIcon}
                                alt="更多"
                            />
                        </div>
                    </div>
                    <div className="button-container">
                        <button
                            type="primary"
                            onClick={changeGoBack}
                            className="confirm btn"
                        >
                            返 回
                        </button>
                    </div>
                </div>
            )}
        </div>
    );
};

export default AdvPromotion;